import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Upselling } from '../../components/upselling/upselling'
import { FeatureContext } from '../../context/useFeatureFlagContext'
import { useUpselling } from '../../hooks/useUpselling'

export function Delivery() {
    const upselling = useUpselling()

    const navigation = useNavigate()

    const { features } = useContext(FeatureContext)

    return (
        <Upselling
            active={features.delivery}
            feature={{
                image: require('../../assets/images/upselling/delivery.png'),
                title: 'Tu Negocio está llegando a la Puerta de Tus Clientes',
                btn: {
                    title: 'Volver al incio',
                    action: () => {
                        upselling.updateUpselling('delivery', true)
                        navigation('/')
                    },
                },
            }}
            pending={{
                headtitle: 'Delivery amiPASS',
                title: 'Lleva Tu Negocio a la Puerta de Tus Clientes',
                text: `Ofrece un servicio de entrega eficiente con Delivery amiPASS. Llega a tus clientes en un radio de 5 km y asegura que tus productos lleguen frescos y a tiempo, sin complicaciones.\n\n¡Con amiPOS, tu negocio llega más lejos sin moverte del local!`,
                list: [
                    'Entrega en un radio de 5 km desde tu comercio',
                    'Mejora la satisfacción del cliente con entregas rápidas y seguras',
                    'Gestiona todos tus pedidos de delivery desde amiPOS',
                    'Aumenta tus ventas ofreciendo la comodidad del servicio a domicilio',
                    'Mantén a tus clientes felices con entregas puntuales y productos frescos',
                ],
                // btn1: {
                //     title: 'Contratar',
                //     action: () => {
                //         navigation('/subscription')
                //     },
                // },
                btn2: {
                    title: 'Hablar con Ventas',
                    action: () => {
                        window.open(
                            'https://amipass.typeform.com/to/BcTVDWHf?typeform-source=amipass.atlassian.net',
                            '_blank'
                        )
                    },
                },
                image: require('../../assets/images/upselling/delivery.png'),
                contract: 'contratando el Plan Estándar y Pro',
            }}
        />
    )
}
